import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { MotionConfig } from "framer-motion";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Projects from "./components/Project";
import Experience from "./components/Experience";
import TechStack from "./components/TechStack";
import Metrics from "./components/Metrics";
import Testimonials from "./components/Testimonials";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App(){

    return (
        // reducedMotion="user" makes Framer Motion automatically respect the
        // OS-level "reduce motion" accessibility setting across the whole app.
        <MotionConfig reducedMotion="user">
        <Router>
                <Navbar/>
                <Home/>
                <Projects id="projects"/>
                <Experience/>
                <TechStack/>
                <Metrics/>
                <Testimonials/>
                <About/>
                <Contact/>
                <Footer/>
      </Router>
      </MotionConfig>
    )
}
